import Vue from "vue";
import { createMapClient } from "../maps";

Vue.prototype.$mapClient = createMapClient();
